export const invoiceSubmissionViews = {
    FORM: 'FORM',
    SUMMARY: 'SUMMARY',
    EXTERNAL: 'EXTERNAL',
    VEHICLE_FORM: 'VEHICLE_FORM',
    MEMBER_FORM: 'MEMBER_FORM',
};
